import { RouteModule } from './AppRoutes';

interface RouteConfig {
    path: string;
    component: RouteModule;
    exact?: boolean;
}

export const ROUTES: {
    PUBLIC: RouteConfig[];
    PRIVATE: RouteConfig[];
    ADMIN: RouteConfig[];
} = {
    PUBLIC: [
        { path: 'login', component: () => import('../components/auth/LoginForm') },
        { path: 'register', component: () => import('../components/auth/RegisterForm') },
        { path: 'forgot-password', component: () => import('../components/auth/ForgotPasswordForm') },
        { path: 'verify-email', component: () => import('../pages/EmailVerification') },
        { path: 'validate-account', component: () => import('../components/auth/ValidateAccountForm') }
    ],
    PRIVATE: [
        { path: '', component: () => import('../pages/HomePage') },
        { path: 'journal', component: () => import('../pages/JournalPage') },
        { path: 'goals', component: () => import('../pages/GoalsPage') },
        { path: 'profile', component: () => import('../pages/ProfilePage') },
        { path: 'ai-mentor', component: () => import('../pages/AIChatPage') },
        { path: 'notifications', component: () => import('../components/NotificationsCenter/NotificationsPage') }
    ],
    ADMIN: [
        { path: 'admin', component: () => import('../components/admin/AdminPage') }
    ]
};